import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { checkRestaurantOpen } from 'helpers/misc';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	checkIfLoaded() {
		const activePage = this.state?.appState?.activePage;
		if (activePage !== 'teaser') {
			const restaurantOpen = checkRestaurantOpen();
			const mainStoreData = this.state?.appState?.main || {};
			const allChompsLoaded = mainStoreData.allChompsLoaded;
			const countdownImagesLoaded = restaurantOpen ? true : mainStoreData.allCountdownImagesLoaded;
			return super.checkIfLoaded() && allChompsLoaded && countdownImagesLoaded;
		}
		const teaserStoreData = this.state?.appState?.teaser || {};
		const introVidReady = teaserStoreData.introVideoLoaded;
		return super.checkIfLoaded() && introVidReady;
	}
}
